module.exports = __webpack_public_path__ + "static/media/martin_bernstein_13.13ee60ae.jpg";